export default {"src":"/_next/static/media/outdoor-space.a6322ba4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};